import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnouncementService } from '@insolution/announcement-data-access';
import { AnnouncementForm } from '@insolution/announcement-ui';
import { Announcement, CreateAnnouncementInput } from '@insolution/graphql-data-access';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-edit-announcement-page',
  imports: [AnnouncementForm, TranslatePipe],
  templateUrl: './edit-announcement-page.html',
  styleUrl: './edit-announcement-page.scss',
})
export class EditAnnouncementPage {
  private announcementService = inject(AnnouncementService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  protected announcement = signal<Announcement | undefined>(undefined);
  protected isSaving = signal(false);

  constructor() {
    this.activatedRoute.params.pipe(takeUntilDestroyed()).subscribe((params) => {
      const id = params['id'];

      if (id) {
        this.setAnnouncement(id);
      }
    });
  }

  protected async onSave(input: CreateAnnouncementInput): Promise<void> {
    this.isSaving.set(true);

    try {
      await this.announcementService.updateAnnouncement(input);
      await this.router.navigate(['/announcements']);
    } finally {
      this.isSaving.set(false);
    }
  }

  protected onCancel(): void {
    this.router.navigate(['/announcements']);
  }

  private async setAnnouncement(id: string): Promise<void> {
    const announcements = await this.announcementService.getAnnouncements();

    this.announcement.set(announcements.find((announcement) => announcement.id === id));
  }
}
